import { useEffect, useState } from "react";
import { AddHeader } from "./AddHeader";
import { getterms } from "./funtionsBD/Mainservice";
import { useTranslation } from "react-i18next";

const AgreementUser = () => {
  const [data, setdata] = useState("<p>User Agreement</p>");
  const { t } = useTranslation();
  const currentlng = localStorage.getItem("i18nextLng") || "en";

  useEffect(() => {
    getdata();
  }, []);

  const getdata = async () => {
    try {
      const params = {
        agreementType: "agreement", //agreement and terms_use_agreement
        language:
          currentlng === "en"
            ? "english"
            : currentlng === "fr"
            ? "french"
            : currentlng === "de"
            ? "german"
            : "spanish",
      };
      const response = await getterms(params);
      const lang =
        currentlng === "en"
          ? "english_content"
          : currentlng === "fr"
          ? "french_content"
          : currentlng === "de"
          ? "german_content"
          : "spanish_content";

      const td = response.data.data[lang];
      setdata(td);
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <>
      <AddHeader title={t("useragreement")} />

      <p className="terms-policy" dangerouslySetInnerHTML={{ __html: data }} />
    </>
  );
};
export default AgreementUser;
